// No navegador, a chave fica só neste navegador (armazenamento local). Use em computador pessoal.
const K = (p: string) => `mp_ia_${p}`;
export const lerChave = async (p: string) => { try { return window.localStorage.getItem(K(p)); } catch { return null; } };
export const salvarChave = async (p: string, v: string | null) => { try { if (v) window.localStorage.setItem(K(p), v); else window.localStorage.removeItem(K(p)); } catch { /* sem armazenamento */ } };
/** Ao sair da conta: a chave da IA não fica neste navegador (0.77). */
export const apagarChaves = async () => {
  try { Object.keys(window.localStorage).filter(k => k.startsWith('mp_ia_')).forEach(k => window.localStorage.removeItem(k)); } catch { /* sem armazenamento */ }
};
